"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function createRegistry() {
  var registered = {};

  var exposeRegistered = function exposeRegistered() {
    return registered;
  };

  var register = function register(units) {
    Object.keys(units).map(function (alias) {
      registered[alias] = units[alias];
    });

    return exposeRegistered();
  };

  return Object.freeze({
    register: register, exposeRegistered: exposeRegistered
  });
};

exports.default = createRegistry;